import {
  API_STATUS_READY,
  API_STATUS_CREATING,
  createAPIReducer,
} from '../../lib/redux';

export const LAYERS_STATUS_READY = API_STATUS_READY;
export const LAYERS_STATUS_CREATING = API_STATUS_CREATING;

const reducer = createAPIReducer('drawinglayers');

export default reducer;
